import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Modal, Button, Loader} from 'semantic-ui-react';
import {months} from '../../../../common/constants/months';
import {getKeyByValue} from '../../../../common/util/dictionary';

class WarningModal extends Component {
  constructor(props) {
    super(props);
    this.onCloseModalClick = this.onCloseModalClick.bind(this);
  }

  onCloseModalClick() {
    this.props.onCloseModal();
  }

  renderLatestSales() {
    const {loadingSalesByDealer, latestSales} = this.props;
    if (loadingSalesByDealer) {
      return <Loader active inline='centered' />;
    }

    const month = latestSales && latestSales.month ? getKeyByValue(months, latestSales.month).toUpperCase() : '';
    return `${month} ${latestSales.year}`;
  }

  render() {
    const {modalWasOpen} = this.props;

    return (
      <Modal size='mini' className='stock-download-modal' open={modalWasOpen}>
        <Modal.Header>
            Datos cargados hasta:
        </Modal.Header>
        
        <Modal.Content scrolling>
          <Modal.Description>
            {this.renderLatestSales()}
          </Modal.Description>
        </Modal.Content>

        <Modal.Actions>
          <Button primary onClick={this.onCloseModalClick}>
            Cerrar
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loadingSalesByDealer': state.sales.loadingSalesByDealer,
    'latestSales': state.sales.latestSales,
  };
};


export default connect(mapStateToProps, {})(WarningModal);
